function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { SidebarContext } from "./SidebarContext";
SidebarProvider.propTypes = {
    children: PropTypes.node,
    active: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
};
export default function SidebarProvider(param) {
    var children = param.children, _param_active = param.active, active = _param_active === void 0 ? null : _param_active;
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(active ? [
        active
    ] : []), 2), expanded = _useState1[0], setExpanded = _useState1[1];
    useEffect(function() {
        // If we go on a page which is not in the sidebar menu, the calculated active item will be null.
        // Since we know this, we want to close all the expanded menus
        if (active === null) {
            setExpanded([]);
        } else if (active !== expanded[0]) {
            //If we expanded more than one menu and we navigate to a certain menu we want to close all the other menus
            setExpanded([
                active
            ]);
        }
    }, [
        active
    ]);
    return /*#__PURE__*/ React.createElement(SidebarContext.Provider, {
        value: {
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            expanded: expanded,
            setExpanded: setExpanded,
            active: active
        }
    }, children);
}
